<template>
  <div class="countryDetail flex-jc-c container">
    <div class="text-center mt-5 pt-5">
      <h2 class="center-header">Continents</h2>
      <div role="group" aria-label="Basic radio toggle button group">
        <label
          v-for="(item, index) in continentInfo.continents"
          :key="index"
          class="btn btn-outline-primary m-2"
        >
          <input
            type="radio"
            class="btn-check"
            name="btnradio"
            :id="`btnradio${index}`"
            :value="index"
            v-model="selectedContinent"
          />
          {{ item.name }}
        </label>
      </div>
    </div>

    <div class="countryDetail__box">
      <div class="text-center">
        <img
          class="countryDetail__img"
          :src="currentContinent.img"
          alt="continent"
        />
      </div>

      <div class="countryDetail__padding" align="justify">
        <div class="b_read">
          <h2 class="mx-auto text-center center-header m-5">{{ currentContinent.name }}</h2>
          <p>{{ currentContinent.information }}</p>
          <ul>
            <li v-for="(option, index) in getOptions(currentContinent.options)" :key="index" class="my-3">
              {{ option }}
            </li>
          </ul>
          <p><strong>Area:</strong> {{ currentContinent.area }}</p>
          <p><strong>Population:</strong> {{ currentContinent.population }}</p>
          <p><strong>GDP (nominal):</strong> {{ currentContinent.gdpNominal }}</p>
          <p><strong>GDP per capita:</strong> {{ currentContinent.gdpPerCapita }}</p>
          <p><strong>Language:</strong> {{ currentContinent.languages }}</p>
          <p><strong>Time Zone:</strong> {{ currentContinent.timeZone }}</p>
        </div>

        <h2 class="mx-auto text-center center-header m-5">
          inte-QT Presence in {{ currentContinent.name }} (Global Coverage, Local Expertise)
        </h2>
        <p class="text-center">
          inte-QT, The trusted industry leader that provides internet solutions in
          {{ currentContinent.name }} through Dedicated lines, Business Broadband, and Wireless connects.
        </p>

    <div class="text-center countryDetail__animatedCircle">
  <img
    src="/images/3gDirrd.png"
    alt="Global Coverage Graphic"
    class="img-fluid"
    style="max-width: 600px; width: 100%; height: auto;"
  />
</div>

        <div class="b_read">
          <h4 class="pt-5 pb-3">Solutions and Services in {{ currentContinent.name }} include:</h4>
          <p><strong>Country Wise Presence:</strong> {{ currentContinent.countryWisePresence }}</p>
          <p><strong>Product Solution Offered:</strong> {{ currentContinent.productSolutionOffered }}</p>
          <p><strong>Multiple Access Options:</strong> {{ currentContinent.multipleAccessOptions }}</p>
          <p><strong>Network Diversity:</strong> {{ currentContinent.networkDiversity }}</p>
          <p><strong>Minimal Latency:</strong> {{ currentContinent.minimalLatency }}</p>
          <p><strong>SLA:</strong> {{ currentContinent.sla }}</p>
          <p><strong>Service Delivery Lead Time:</strong> {{ currentContinent.serviceDeliveryLeadTime }}</p>
          <p><strong>Bandwidth:</strong> {{ currentContinent.bandwidth }}</p>
          <p><strong>IPV6 Ready Network:</strong> {{ currentContinent.ipv6ReadyNetwork }}</p>
          <p><strong>Service Assurance:</strong> {{ currentContinent.serviceAssurance }}</p>
          <p><strong>Guaranteed Domestic Transit Quality:</strong> {{ currentContinent.guaranteedDomesticTransitQuality }}</p>
          <p><strong>Premium Performance:</strong> {{ currentContinent.premiumPerformance }}</p>
          <p><strong>IP Range:</strong> {{ currentContinent.ipRange }}</p>

          <h4 class="mt-5 pt-5">Reference by:</h4>
          <ul>
            <li><a href="https://www.worldbank.org/en/home" target="_blank">World Bank Website</a></li>
            <li><a href="https://bangkok.unesco.org/" target="_blank">Unesco Bangkok</a></li>
          </ul>
        </div>
      </div>
    </div>

    <GetInTouch />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import continentInfo from '@/data/continentInfo.json'

const selectedContinent = ref(3)

const currentContinent = computed(() => {
  return continentInfo.continents[selectedContinent.value]
})

// Keep this if you still need to show options
function getOptions(options) {
  return Object.values(options).slice(0, 4);
}
</script>

<style scoped>
.countryDetail {
  color: #000;
  line-height: 1.5;
}

p {
    font-family: Poppins, sans-serif;
    font-size: 20px;
}

.b_read {
    max-width: 70ch;
    margin: auto;
    font-family: Poppins, sans-serif;
    font-size: 18px;
}

.img{
  width: 50%;
}

.circle-text{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 22px;
    font-weight: bold;
    color: #333;}

.countryDetail__spacing {
  margin: 0 0 0 2rem;
}

@media (max-width: 768px) {
  .countryDetail__spacing {
    margin: 2rem 0 4rem 3rem;
  }
}

.countryDetail__padding {
  padding: 3rem;
}

@media (max-width: 768px) {
  .countryDetail__padding {
    padding: 1rem 0;
  }
}

.countryDetail__box {
  margin: 8rem 0 5rem 0;
}

@media (max-width: 768px) {
  .countryDetail__box {
    margin: 1rem;
  }
}

.countryDetail__box-circle {
  border: 2px solid black;
  border-radius: 50%;
  width: 200px;
  height: 200px;
  margin: auto;
}

@media (max-width: 768px) {
  .countryDetail__box-circle {
    margin: 1rem auto;
  }
}

.countryDetail__box-circle-p {
  margin: 4.5rem 0rem;
}

.countryDetail__img {
  width: 59vw;
  height: 50vh;
  object-fit: cover;
  object-position: 50% 50%;
  filter: drop-shadow(1px 5px 40px rgb(85, 83, 83)) saturate(160%);
  top: 124vh;
  border-radius: 15px;
}

@media (max-width: 1200px) {
  .countryDetail__img {
    top: 143.5vh;
    width: 80vw;
  }
}

@media (max-width: 768px) {
  .countryDetail__img {
    top: 161.5vh;
    width: 70vw;
  }
}

@media (max-width: 576px) {
  .countryDetail__img {
    top: 317vh;
    width: 100%;
  }
}

.countryDetail__animatedCircle {
  padding: 5rem;
  
}

@media (max-width: 768px) {
  .countryDetail__animatedCircle {
    margin: 0;
    padding: 0;
  }
}
</style>
 
